// extracted by mini-css-extract-plugin
module.exports = {"error-img-main":"cc_error-img-main_1014780759","errorImgMain":"cc_error-img-main_1014780759"};